import api from '@/configs/GlobalRequestHandler.js';

export default {
  getByCampaign: (campaignId) => {
    return api.getRequest(`/participants/${campaignId}`);
  },
  getOrders: (campaignId, page, body) => {
    return api.postRequestWithBody(`/participants/orders/${campaignId}/${page}`, body);
  },
  markAsPaid: (id) => {
    return api.putRequest(`/participants/${id}/mark_paid`);
  },
  cancelOrder: (campaignId, orderId) => {
    return api.deleteRequest(`/participants/${campaignId}/${orderId}`);
  },
  exportOrders: (campaignId, body) => {
    return api.postRequestWithBody(`/participants/orders/${campaignId}`, body);
  },
  getMinMaxQuotas: (campaignId, body) => {
    return api.postRequestWithBody(`/participants/min_max/${campaignId}`, body);
  },
  getRanking: (campaignId, page, params) => {
    return api.getRequestWithBody(`/participants/ranking/${campaignId}/${page}`, { params });
  }
}
